import { render, staticRenderFns } from "./ruta-influencers.vue?vue&type=template&id=9ef7c6e4&"
import script from "./ruta-influencers.vue?vue&type=script&lang=js&"
export * from "./ruta-influencers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports